import { useEffect } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

import { isProjectOnboardingStage } from 'src/data/onboarding';
import { isOnSingleProjectRoute } from 'src/lib/routing';
import { useOnboardingActions } from 'src/store';
import useViewState from './useViewState';
import { getActiveOnboardingStage, isProjectReadyForOnboardingStage } from './utils';

export const OnboardingRouteGuard = () => {
  const location = useLocation();

  const { currentUser, currentProject } = useViewState();
  const onboardingActions = useOnboardingActions();

  useEffect(() => {
    // We need both user start onboarding
    if (!currentUser) {
      onboardingActions.stopOnboarding();
      return;
    }

    // Usually we should not do anything if onboarding is already in progress
    if (onboardingActions.getIsActive()) {
      // We need "current project" to start "project" onboarding, and we should be on single "project" route
      // User might click "back" in browser, so we need to stop onboarding, if it was active.
      const currentStage = onboardingActions.getCurrentStage();
      if (
        isProjectOnboardingStage(currentStage) &&
        (!currentProject || !isOnSingleProjectRoute(location.pathname))
      ) {
        onboardingActions.stopOnboarding();
      }
      return;
    }

    // Take first of pending onboarding stages and activate it
    const stage = getActiveOnboardingStage(currentUser, currentProject);

    if (isProjectReadyForOnboardingStage(stage, currentProject)) {
      onboardingActions.startOnboarding(stage, currentProject);
    } else {
      onboardingActions.stopOnboarding();
    }
  }, [currentUser, currentProject, onboardingActions, location.pathname]);

  return null;
};
